import React from "react"
import * as styles from "./categoriesList.module.scss"
import CategoryItem from "../categoryItem/categoryItem"

const CategoriesList = ({ categories, setActiveCategory, activeCategory }) => (
  <ul className={styles.categoryList}>
    {categories.map((category, index) => (
      <CategoryItem
        category={category}
        key={index}
        setActiveCategory={setActiveCategory}
        activeCategory={activeCategory}
      />
    ))}
  </ul>
)

export default CategoriesList
